/** Habilidades de broma. El servidor valida alcance, enfriamiento y protección por objetivo. */
export type AbilityId = 'push' | 'banana' | 'bighead' | 'paint';
export type SpecialAbilityId = Exclude<AbilityId, 'push'>;

export interface AbilityDef {
  id: AbilityId;
  name: string;
  description: string;
  icon: string;
  /** Enfriamiento en segundos. */
  cooldown: number;
  /** Duración del efecto en segundos. */
  duration: number;
  /** Alcance en metros. */
  range: number;
  /** Radio del área de efecto (si aplica). */
  radius: number;
}

export const ABILITIES: Record<AbilityId, AbilityDef> = {
  push: {
    id: 'push',
    name: 'Empujón',
    description: 'Empuja al jugador que tengas delante. Pierde el equilibrio y suelta lo que lleve.',
    icon: '🫸',
    cooldown: 3,
    duration: 0.9,
    range: 2.3,
    radius: 0,
  },
  banana: {
    id: 'banana',
    name: 'Suelo resbaladizo',
    description: 'Deja un charco de jabón. Quien lo pise patinará sin control.',
    icon: '🍌',
    cooldown: 14,
    duration: 12,
    range: 0,
    radius: 2.6,
  },
  bighead: {
    id: 'bighead',
    name: 'Cabezón',
    description: 'Infla la cabeza del jugador más cercano frente a ti durante unos segundos.',
    icon: '🎈',
    cooldown: 18,
    duration: 8,
    range: 9,
    radius: 0,
  },
  paint: {
    id: 'paint',
    name: 'Bomba de pintura',
    description: 'Lanza una bomba que pinta a todos los que estén cerca del impacto.',
    icon: '🎨',
    cooldown: 16,
    duration: 6,
    range: 10,
    radius: 3.2,
  },
};

export const SPECIAL_ABILITIES: SpecialAbilityId[] = ['banana', 'bighead', 'paint'];

/** Reglas anti-acoso: protección del objetivo tras recibir una broma y límite por pareja. */
export const PRANK_RULES = {
  /** Segundos de inmunidad tras recibir una broma dirigida. */
  TARGET_IMMUNITY_S: 3,
  /** Máximo de bromas del mismo jugador al mismo objetivo en la ventana. */
  MAX_SAME_TARGET: 3,
  SAME_TARGET_WINDOW_S: 60,
  /** Máximo de charcos activos por jugador. */
  MAX_BANANAS_PER_PLAYER: 2,
  /** Impulso del empujón. */
  PUSH_IMPULSE: 10,
  PUSH_UP: 4.5,
} as const;

/** Efectos visuales/de estado temporales sobre un jugador. Bits del campo `fx` del snapshot. */
export const FX = {
  BIGHEAD: 1,
  PAINT: 2,
  CARRYING: 4,
  DISCONNECTED: 8,
  HIDDEN: 16,
  STUNNED: 32,
  IMMUNE: 64,
  DISGUISE: 128,
} as const;
